import {styled} from "@mui/material/styles"
import {Anchor} from "../../component"

export const StyledAnchor = styled(Anchor)`
    flex-direction: row;
`
